import React from 'react';
import siteIds from '../../../constants/siteIds';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const contactUsTemplate = (siteName, contactLink) => {
	const currentYear = new Date().getFullYear();
	return (
		<Box>
			<Typography
				align='center'
				sx={{ color: 'secondary.contrastText', px: { xs: 3, sm: 0, md: 0, lg: 0 } }}
			>
				&copy; {currentYear} {siteName} | Questions or comments?{' '}
				<a href={contactLink} target='blank' role='button' style={{ textDecoration: 'none' }}>
					<Typography
						component='span'
						sx={{ color: 'secondary.contrastText', textDecoration: 'underline' }}
					>
						Contact Us
					</Typography>
				</a>
			</Typography>
			<Typography
				align='center'
				mt={3}
				sx={{ color: 'secondary.contrastText', px: 2, fontSize: { xs: '0.8em', md: '0.9em' } }}
			>
				* If you were promised a benefit that is not on this site, call us at 1-800-475-1942.
			</Typography>
		</Box>
	);
};

export default function (siteId) {
	switch (siteId) {
		case siteIds.giftCardConnection:
			return contactUsTemplate(
				'Gift Card Connection',
				'https://www.mygiftcardconnection.com/contact/'
			);
		case siteIds.valuePlus:
			return contactUsTemplate('Value Plus', 'https://www.valueplusonline.com/contact/');
		case siteIds.savingsCentral:
			return contactUsTemplate('Savings Central', 'https://www.isavingscentral.com/contact/');
		case siteIds.tasteForSavings:
			return contactUsTemplate('Taste for Savings', 'https://www.tasteforsavings.com/contact/');
		case siteIds.homePlay:
			return contactUsTemplate('HomePlay', 'https://www.homeplayonline.com/contact/');
		case siteIds.funSource:
			return contactUsTemplate('FunSource', 'https://www.myfunsource.com/contact/');
		case siteIds.essentialsForHome:
			return contactUsTemplate('Essentials for Home', 'https://www.essentialsforhome.com/contact/');
		case siteIds.valueAccess:
			return contactUsTemplate('Value Access', 'https://www.myvalueaccess.com/contact/');
		case siteIds.pulse:
			return contactUsTemplate('Pulse', 'https://www.mypulseonline.com/contact/');
		case siteIds.rizzbates:
			return contactUsTemplate('RizzBates', 'https://www.rizzbates.com/contact/');
		case siteIds.budgetSource:
			return contactUsTemplate('Budget Source', 'https://www.mybudgetsource.com/contact/');
		case siteIds.buyersPlus:
			return contactUsTemplate(
				'Buyers Plus',
				'https://mybuyersplus.onlinemembershipservices.com/contact/'
			);
		case siteIds.saversSolution:
			return contactUsTemplate(
				'Savers Solution',
				'https://mybuyersplus.onlinemembershipservices.com/contact/'
			);
		case siteIds.valueSource:
			return contactUsTemplate(
				'Value Source',
				'https://valuesourceonline.onlinemembershipservices.com/contact/'
			);
		default:
			return '';
	}
}
